import Image from 'app/Components/Shared/Image/image';
import React,{useEffect,useState} from 'react';
import { getImageProps } from 'app/utilities/ImageProps';

import './Main.scss'


function Main({iContent,context}) {
    const imageGuides = getImageProps(iContent?.imageGuides,context);
    const itemsGuides = iContent.itemsGuides.expandedValue?.map((item, index) => {
        const linkText = item.linkText.value; 
        const linkButton = item.linkButton.value; 

        return (
            <div key={index} className="guide-link">
            <a href={linkButton} target="_blank" rel="noopener noreferrer">
                {linkText}
            </a>
            </div>
        );
    });

    return (
        <div className='link-container'>
            <div className="guides-list">
            <Image src={imageGuides.src} alt='image' />
            <h2>{iContent?.titleGuides?.value}</h2>
            {itemsGuides}
            </div>
        </div>
    );
}

export default Main;
